import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Popup } from 'semantic-ui-react';

import { QUEUE_ACTION, QUEUE_VIEW, ROW_ACTION_LABELS } from '../../constants/onboardingQueue';
import { rowActionState, rowActions } from '../../utilities/onboardingQueue';

const ACTION_TEST_IDS = {
  [QUEUE_ACTION.ACTIVATE]: 'queue-action-activate',
  [QUEUE_ACTION.OPT_OUT]: 'queue-action-opt-out',
  [QUEUE_ACTION.EDIT_STATUS]: 'queue-action-edit-status',
  [QUEUE_ACTION.NOTES]: 'queue-action-notes',
  [QUEUE_ACTION.SEE_DETAILS]: 'queue-action-see-details',
};

const RowActionMenu = ({ view, row, onAction }) => (
  <Dropdown
    icon='ellipsis horizontal'
    pointing='top right'
    className='no-pointer-dropdown'
    data-testid='queue-row-menu'
  >
    <Dropdown.Menu>
      {rowActions(view, row).map(action => {
        const { disabled, reason } = rowActionState(action, row);
        const testId = ACTION_TEST_IDS[action];
        const reasonId = `${testId}-reason-${row.dealers[0].flatRateOfferId}`;
        const label = ROW_ACTION_LABELS[action];

        return (
          <Dropdown.Item
            key={action}
            disabled={disabled}
            data-testid={testId}
            aria-label={reason ? label : undefined}
            aria-describedby={reason ? reasonId : undefined}
            onClick={disabled ? undefined : () => onAction(action, row)}
          >
            {reason ? (
              <Popup
                size='small'
                position='left center'
                mouseEnterDelay={0}
                content={reason}
                trigger={(
                  <span className='queue-disabled-item-label'>{label}</span>
                )}
              />
            ) : label}
            {reason && (
              <span
                id={reasonId}
                className='queue-visually-hidden'
                data-testid={`${testId}-reason`}
              >
                {reason}
              </span>
            )}
          </Dropdown.Item>
        );
      })}
    </Dropdown.Menu>
  </Dropdown>
);

RowActionMenu.propTypes = {
  view: PropTypes.oneOf(Object.values(QUEUE_VIEW)).isRequired,
  row: PropTypes.shape({
    flatRateOfferBatchId: PropTypes.string,
    dealers: PropTypes.arrayOf(PropTypes.shape({
      status: PropTypes.string,
      flatRateOfferId: PropTypes.string,
    })).isRequired,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
};

export default RowActionMenu;
